import React, { useState } from 'react'
import { useQuery } from 'react-query'
import { fetchMemberByFilters } from '../connections/requests';
import { useForm } from '@mantine/form';
import { ActionIcon, Button, Checkbox, Radio, TextInput } from '@mantine/core';
import { IconX } from '@tabler/icons-react';

export default function MemberListMaker() {
    const [filter,setFilter] = useState("");
    const form = useForm();
    const memberQuery = useQuery(["member","filters",filter],fetchMemberByFilters);
  return (
    <form>
        <Checkbox.Group value='genre' {...form.getInputProps("genre")}>
            <Checkbox label="Homme" value={"homme"}/>
            <Checkbox label="Femme" value={"femme"}/>
        </Checkbox.Group>
        <Checkbox.Group   {...form.getInputProps("type")}>
            <Checkbox label="Régulier" value={"Régulier"}/>
            <Checkbox label="Sympathisant" value={"Sympathisant"}/>
            <Checkbox label="Non Membre" value={"Non-Membre"}/>
            <Checkbox label="Autres" value={"Autres"}/>
        </Checkbox.Group>
        <Checkbox.Group {...form.getInputProps("active")}>
            <Checkbox label="Active" value={"active"}/>
            <Checkbox label="Doit Renouveler" value={"waiting"}/>
            <Checkbox label="Inactive" value={"inactive"}/>
        </Checkbox.Group>
        <Button onClick={()=> setFilter(form.values)}>Filtrer</Button>
    </form>
  )
}
